document.addEventListener('DOMContentLoaded', function () {
    const wrap = document.querySelector('.cam-story-wrap');
    if (!wrap) return;

    wrap.querySelectorAll('.play-pause-btn[data-video-id]').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const videoId = this.dataset.videoId;
        const video = document.getElementById(videoId);
        const playIcon = this.querySelector('.play-icon');
        const pauseIcon = this.querySelector('.pause-icon');
        if (!video) return;
        if (video.paused) {
          video
            .play()
            .then(() => {
              if (playIcon) playIcon.style.display = 'none';
              if (pauseIcon) pauseIcon.style.display = 'block';
            })
            .catch(() => {});
        } else {
          video.pause();
          if (playIcon) playIcon.style.display = 'block';
          if (pauseIcon) pauseIcon.style.display = 'none';
        }
      });
    });

    wrap.querySelectorAll('.mute-btn[data-video-id]').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const videoId = this.dataset.videoId;
        const video = document.getElementById(videoId);
        const muteIcon = this.querySelector('.mute-icon');
        const unmuteIcon = this.querySelector('.unmute-icon');
        if (!video) return;
        video.muted = !video.muted;
        if (video.muted) {
          if (muteIcon) muteIcon.style.display = 'block';
          if (unmuteIcon) unmuteIcon.style.display = 'none';
          this.classList.add('muted');
        } else {
          if (muteIcon) muteIcon.style.display = 'none';
          if (unmuteIcon) unmuteIcon.style.display = 'block';
          this.classList.remove('muted');
        }
      });
    });

    wrap.querySelectorAll('video').forEach((video) => {
      video.addEventListener('play', function () {
        const btn = wrap.querySelector(`.play-pause-btn[data-video-id="${this.id}"]`);
        if (!btn) return;
        const playIcon = btn.querySelector('.play-icon');
        const pauseIcon = btn.querySelector('.pause-icon');
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = 'block';
      });
      video.addEventListener('pause', function () {
        const btn = wrap.querySelector(`.play-pause-btn[data-video-id="${this.id}"]`);
        if (!btn) return;
        const playIcon = btn.querySelector('.play-icon');
        const pauseIcon = btn.querySelector('.pause-icon');
        if (playIcon) playIcon.style.display = 'block';
        if (pauseIcon) pauseIcon.style.display = 'none';
      });
      video.addEventListener('volumechange', function () {
        const btn = wrap.querySelector(`.mute-btn[data-video-id="${this.id}"]`);
        if (!btn) return;
        const muteIcon = btn.querySelector('.mute-icon');
        const unmuteIcon = btn.querySelector('.unmute-icon');
        if (this.muted) {
          if (muteIcon) muteIcon.style.display = 'block';
          if (unmuteIcon) unmuteIcon.style.display = 'none';
          btn.classList.add('muted');
        } else {
          if (muteIcon) muteIcon.style.display = 'none';
          if (unmuteIcon) unmuteIcon.style.display = 'block';
          btn.classList.remove('muted');
        }
      });
    });

    function initLayout6Split(container) {
      const roots = container.querySelectorAll ? container.querySelectorAll('[data-layout6-root]') : [];
      roots.forEach((root) => {
        if (root.dataset.layout6Init === '1') return;
        const source = root.querySelector('[data-layout6-source]');
        const left = root.querySelector('[data-layout6-left]');
        const right = root.querySelector('[data-layout6-right]');
        if (!source || !left || !right) return;

        const children = Array.from(source.children).filter((n) => n.nodeType === 1);
        if (children.length === 0) {
          root.dataset.layout6Init = '1';
          return;
        }

        children.forEach((node) => {
          const goRight =
            (typeof node.matches === 'function' && node.matches('.cam-layout-6__item--right')) ||
            !!(node.querySelector && node.querySelector('.cam-layout-6__item--right'));
          (goRight ? right : left).appendChild(node);
        });

        source.setAttribute('hidden', '');
        source.setAttribute('aria-hidden', 'true');
        root.classList.add('cam-layout-6__cols--split');
        root.dataset.layout6Init = '1';
      });
    }

    function initLayout4Carousels(container) {
      const roots = container.querySelectorAll ? container.querySelectorAll('[data-layout4-root]') : [];
      roots.forEach((root) => {
        if (root.dataset.layout4Init === '1') return;
        const viewport = root.querySelector('[data-layout4-viewport]');
        const track = root.querySelector('[data-layout4-track]') || root.querySelector('.cam-layout-4__slides');
        const slides = root.querySelectorAll('.cam-layout-4__slide');
        const slideBlocks = track ? Array.from(track.children).filter((n) => n.nodeType === 1) : [];

        if (!viewport || slideBlocks.length <= 1) return;
        root.dataset.layout4Init = '1';

        let progressFill = root.querySelector('[data-layout4-progress]');
        if (!progressFill) {
          const slider = root.querySelector('[data-layout4-slider]');
          if (slider) {
            const bar = document.createElement('div');
            bar.className = 'cam-layout-4__progress-container';
            bar.innerHTML = '<div class="cam-layout-4__progress-fill" data-layout4-progress></div>';
            slider.appendChild(bar);
            progressFill = bar.querySelector('[data-layout4-progress]');
          }
        }

        let currentIndex = 0;
        let autoTimer = null;
        let scrollEndTimer = null;

        function getMaxScroll() {
          return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        }

        function updateProgressFromScroll() {
          if (!progressFill) return;
          const maxScroll = getMaxScroll();
          if (maxScroll <= 0.5) {
            progressFill.style.width = '100%';
            return;
          }
          let sl = viewport.scrollLeft;
          if (sl >= maxScroll - 1.5) sl = maxScroll;
          const pct = sl / maxScroll;
          progressFill.style.width = Math.min(1, Math.max(0, pct)) * 100 + '%';
        }

        function getIndexFromScroll() {
          if (!slideBlocks.length) return 0;
          const vpRect = viewport.getBoundingClientRect();
          let best = 0;
          let bestDelta = Infinity;
          slideBlocks.forEach((el, i) => {
            const r = el.getBoundingClientRect();
            const d = Math.abs(r.left - vpRect.left);
            if (d < bestDelta) {
              bestDelta = d;
              best = i;
            }
          });
          return best;
        }

        function goToSlide(index, smooth) {
          const n = slideBlocks.length;
          const maxScroll = getMaxScroll();
          if (index >= n - 1) {
            viewport.scrollTo({ left: maxScroll, behavior: smooth ? 'smooth' : 'auto' });
            currentIndex = n - 1;
            requestAnimationFrame(updateProgressFromScroll);
            return;
          }
          const el = slideBlocks[index];
          if (!el) return;
          const vpRect = viewport.getBoundingClientRect();
          const elRect = el.getBoundingClientRect();
          const delta = elRect.left - vpRect.left;
          let targetLeft = viewport.scrollLeft + delta;
          targetLeft = Math.max(0, Math.min(targetLeft, maxScroll));
          viewport.scrollTo({ left: targetLeft, behavior: smooth ? 'smooth' : 'auto' });
          currentIndex = index;
          requestAnimationFrame(updateProgressFromScroll);
        }

        function nextSlideAuto() {
          const n = slideBlocks.length;
          if (n < 2) return;
          const idx = getIndexFromScroll();
          const next = (idx + 1) % n;
          goToSlide(next, true);
        }

        function scheduleAuto() {
          if (autoTimer) clearInterval(autoTimer);
          if (slideBlocks.length <= 1) return;
          autoTimer = window.setInterval(nextSlideAuto, 5000);
        }

        function pauseAllVideos() {
          slides.forEach((s) => {
            const v = s.querySelector('video');
            if (v) v.pause();
          });
        }

        function syncVideosToScroll() {
          pauseAllVideos();
          const idx = getIndexFromScroll();
          currentIndex = idx;
          const slide = slides[idx];
          if (!slide) return;
          const vid = slide.querySelector('video');
          if (vid) {
            vid.muted = true;
            vid.play().catch(() => {});
          }
        }

        function onScroll() {
          updateProgressFromScroll();
          currentIndex = getIndexFromScroll();
          clearTimeout(scrollEndTimer);
          scrollEndTimer = setTimeout(() => {
            syncVideosToScroll();
            scheduleAuto();
          }, 150);
        }

        viewport.addEventListener('scroll', onScroll, { passive: true });

        const onResize = () => {
          updateProgressFromScroll();
          syncVideosToScroll();
        };
        window.addEventListener('resize', onResize);

        goToSlide(0, false);
        requestAnimationFrame(() => {
          updateProgressFromScroll();
          syncVideosToScroll();
        });
        window.setTimeout(() => {
          updateProgressFromScroll();
          syncVideosToScroll();
          scheduleAuto();
        }, 100);
      });
    }

    initLayout6Split(wrap);
    initLayout4Carousels(wrap);
    document.addEventListener('shopify:section:load', function (ev) {
      const sec = ev.target;
      if (sec && sec.querySelector && sec.querySelector('[data-layout6-root]')) {
        sec.querySelectorAll('[data-layout6-root]').forEach((r) => {
          delete r.dataset.layout6Init;
        });
        initLayout6Split(sec);
      }
      if (sec && sec.querySelector && sec.querySelector('[data-layout4-root]')) {
        sec.querySelectorAll('[data-layout4-root]').forEach((r) => {
          delete r.dataset.layout4Init;
        });
        initLayout4Carousels(sec);
      }
    });

    // Top banner description 펼치기/접기 (모바일)
    (function initDescExpandable() {
      const expandables = document.querySelectorAll('.cam-desc-expandable');
      const isMobile = () => window.innerWidth <= 768;

      function checkOverflow(wrap) {
        const content = wrap.querySelector('.cam-desc-content');
        const toggle = wrap.querySelector('[data-desc-toggle]');
        if (!content || !toggle) return;
        if (!isMobile()) {
          wrap.classList.remove('cam-desc-has-overflow', 'is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
          return;
        }
        const isExpanded = wrap.classList.contains('is-expanded');
        const overflow = isExpanded || content.scrollHeight > content.clientHeight;
        wrap.classList.toggle('cam-desc-has-overflow', overflow);
      }

      expandables.forEach((wrap) => {
        const content = wrap.querySelector('.cam-desc-content');
        const toggle = wrap.querySelector('[data-desc-toggle]');
        if (!content || !toggle) return;

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (!isMobile()) return;
          wrap.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', wrap.classList.contains('is-expanded'));
        });

        checkOverflow(wrap);
      });

      window.addEventListener('resize', () => expandables.forEach(checkOverflow));
    })();
  });
